import { CompanyProfileContent } from "../../features/companyWorkspace";

function CompanyProfileScreen() {
  return <CompanyProfileContent />;
}

export default CompanyProfileScreen;
